import { Wine } from '@/shared/models/Wine';

export class Zalto extends Wine {
}
